import React from 'react';

function Features() {
  const features = [
    {
      title: 'Rich Tradition',
      description: 'Pecel Madiun preserves Javanese culinary heritage with each plate.'
    },
    {
      title: 'Made with Fresh Ingredients',
      description: 'A colorful mix of vegetables, herbs, and house-made peanut sauce.'
    },
    {
      title: 'Bold and Balanced Flavor',
      description: 'Sweet, spicy, and nutty notes combine for a memorable meal.'
    },
    {
      title: 'Warm Hospitality',
      description: 'Enjoy a comforting dining experience inspired by East Java.'
    },
  ];

  return (
    <section id="story" className="py-16 md:py-24 bg-[#F3D9C6]">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#7C2D12] mb-12">
          Why Pecel Madiun
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-cream p-8 rounded-[2rem] shadow-lg border border-red-900/10 hover:-translate-y-1 transition">
              <h3 className="text-2xl font-semibold text-red-800 mb-3">{feature.title}</h3>
              <p className="text-[#4D2A1F] leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
